<template>
	<div class="job-vita--grid-matching">
		<div v-if="matching.score !== null" class="matching">
			<div class="matching--category matching--category--no-y-padding mb-1">
				<div
					class="matching--category-items matching--category-items-no-item-x-padding matching--category-items-background-transparent"
				>
					<MatchingItem
						:score="matching.score"
						:max-score="matching.maxScore"
						class="matching--item-no-top-margin"
					/>
				</div>
			</div>
		</div>
		<IconLink
			v-else-if="matching.match !== null"
			:icon="matching.match ? 'check-circle' : 'cross-circle'"
			:text="matching.match ? 'Match' : 'Kein Match'"
			:color="matching.match ? 'green' : 'red'"
			:with-arrow="false"
			less-left-padding
			@click="showUpgradePopUp = true"
		/>
		<IconLink
			v-else
			icon="question-circle"
			text="Matching"
			color="yellow"
			:with-arrow="false"
			less-left-padding
			@click="showUpgradePopUp = true"
		/>
		<UpgradePopUp
			v-if="showUpgradePopUp"
			:job-profile-id="jobProfileId"
			:pseudonym-id="pseudonymId"
			@upgrade="onUpgrade"
			@hidden="showUpgradePopUp = false"
		/>
	</div>
</template>

<script>
import MatchingItem from "@/vue/common/matching/Item"
import IconLink from "@/vue/common/IconLink"
import UpgradePopUp from "@/vue/permission/UpgradePopUp";

export default {

	components: {
		UpgradePopUp,
		MatchingItem,
		IconLink,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: true,
		},
		matching: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			showUpgradePopUp: false,
		};
	},

	methods: {
		onUpgrade ()
		{
			this.showUpgradePopUp = false;

			this.$emit('upgrade');
		}
	}
}
</script>
